import React, { Component } from "react";
import { Box, Heading } from "grommet";
import TaskInstanceTable from "./TaskInstanceTable";

export class TaskInstancesContainer extends Component {
  state = {
    taskInstanceData: []
  };

  componentDidMount = () => {
    let taskInstanceData = [];
    if (this.props.taskInstances.length !== 0) {
      this.props.taskInstances.forEach(taskInstance => {
        if (taskInstanceData.length === 0) {
          const taskInstanceObject = {
            taskName: taskInstance.Task.Name,
            taskInstances: [taskInstance]
          };
          taskInstanceData.push(taskInstanceObject);
        } else {
          let taskInstDataContainedTaskInstance = false;
          taskInstanceData.forEach((taskInstanceObject, index) => {
            if (taskInstanceObject.taskName === taskInstance.Task.Name) {
              taskInstDataContainedTaskInstance = true;
              taskInstanceData[index].taskInstances.push(taskInstance);
            }
          });
          if (!taskInstDataContainedTaskInstance) {
            const taskInstanceObject = {
              taskName: taskInstance.Task.Name,
              taskInstances: [taskInstance]
            };
            taskInstanceData.push(taskInstanceObject);
          }
        }
      });
    }
    const newState = {
      ...this.state,
      taskInstanceData: taskInstanceData
    };
    this.setState(newState);
    //console.log("task instance data = ", taskInstanceData);
  };
  render() {
    if (this.state.taskInstanceData.length === 0) {
      return <Box>No Tasks</Box>;
    } else {
      return (
        <Box>
          {this.state.taskInstanceData.map((task, index) => {
            return (
              <Box key={index}>
                <Box align="center" justify="center">
                  <Heading size="small" level="4" textAlign="center">
                    {task.taskName}
                  </Heading>
                </Box>
                <Box border={{ color: "grey", size: "xsmall" }}>
                  {task.taskInstances.map((taskInstance, index2) => {
                    return (
                      <Box
                        key={index2}
                        margin="small"
                        pad="small"
                        border={{
                          side: "all",
                          size: "small",
                          color: "black",
                          style: "inset"
                        }}
                      >
                        <TaskInstanceTable
                          firebase={this.props.firebase}
                          taskInstance={taskInstance}
                          currentBuilding={this.props.currentBuilding}
                        ></TaskInstanceTable>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            );
          })}
        </Box>
      );
    }
  }
}

export default TaskInstancesContainer;
